/* Redesign 2026 (lr_cart): Plus/Minus am Mengenfeld im Warenkorb.
   Setzt nur den Wert im bestehenden <input is="quantity-input"> und löst "change" aus;
   die AJAX-Änderung macht weiterhin <line-item-quantity> aus theme.js. */
(function () {
  if (window.__lrCartQty) return;
  window.__lrCartQty = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-lr-qty]');
    if (!button) return;

    var input = button.closest('.lr-qty') && button.closest('.lr-qty').querySelector('input.quantity-input');
    if (!input) return;

    var direction = parseInt(button.getAttribute('data-lr-qty'), 10);
    var step = parseInt(input.step, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var current = parseInt(input.value, 10) || min;
    var next = Math.min(max, Math.max(min, current + direction * step));

    if (next === current) return;
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Passende Shorts: Farbwahl aktualisiert Bild, Preis und Link der Zeile */
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.classList || !select.classList.contains('lr-xs__color')) return;

    var option = select.options[select.selectedIndex];
    var row = select.closest('.lr-xs__row');
    if (!option || !row) return;

    var image = row.querySelector('.lr-xs__img img');
    if (image && option.dataset.img) {
      image.removeAttribute('srcset');
      image.src = option.dataset.img;
    }
    var price = row.querySelector('.lr-xs__price');
    if (price) price.textContent = option.dataset.price;
    row.querySelectorAll('a').forEach(function (link) { link.href = option.dataset.url; });
  });
})();
